<template>
  <template v-if="props.showAlways || mainMenuStore.leakProfile?.defender_subscription === 'free'" >
    <slot />
    <span class="pro-badge" :style="{ '--pro-badge-color': props.color }">
      <template v-if="props.invert">{{ mainMenuStore.leakProfile?.defender_subscription === 'free' ? "/FREE" :"/PRO" }}</template>
      <template v-else>{{ mainMenuStore.leakProfile?.defender_subscription === 'free' ? "/PRO" : "/FREE"}}</template>
    </span>
  </template>
  <span v-else><slot /></span>
</template>

<script setup lang="ts">
const mainMenuStore = useMainMenuStore();
const props = withDefaults(defineProps<{
  showAlways?: boolean,
  invert?: boolean,
  color?: string,
}>(), {
  showAlways: false,
  invert: false,
  color: "rgb(var(--v-theme-primary))",
});
</script>

<style lang="scss" scoped>
.pro-link {
  pointer-events: auto;
  text-decoration: none;
  color: "inherit";
}
.pro-badge {
  color: var(--pro-badge-color);
  font-weight: 900;
  white-space: nowrap;
}
</style>
